// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3MvK8","select":"Header_select__2n4tv","clinic":"Header_clinic__AfLIs"};